<template>
	<div id="loader">
        <div class="loader"></div>
    </div>
</template>

<script>
	export default {    
		name: 'Loader'
	}
</script>


